export default __webpack_public_path__ + "static/media/mask1.08707e49.jpeg";